export class BackupZeroEtlTableSelection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "BackupZeroEtlTableSelectionMode",
            "format": ""
        },
        {
            "name": "patterns",
            "baseName": "patterns",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlTableSelection.attributeTypeMap;
    }
    constructor() {
    }
}
